module.exports = __webpack_public_path__ + "assets/img/recordPrize.200f16f9.png";